/**
 * World Cup 2026 landing-page content.
 *
 * GENERATED from the UX prototype (claude.ai/design handoff "World Cup 2026 (Remix)",
 * sourced from wanderu/marketing). Do not hand-edit match data casually — prefer
 * regenerating, or update deliberately and keep the integrity test (data.test.ts) green.
 */
import type { WorldCupContent } from './types'

export const worldCupContent: WorldCupContent = {
    hero: {
        eyebrow: 'FIFA World Cup 2026™ · Jun 11 – Jul 19',
        headlineLines: ['Bus & train tickets to every', 'US World Cup stadium.'],
        sub: '48 countries. 11 US cities. Whether you live nearby or you’re traveling from further away, here’s how to get to every city and every stadium.',
        stats: [
            {
                n: '78',
                l: 'Games',
            },
            {
                n: '11',
                l: 'US Cities',
            },
            {
                n: '39',
                l: 'Days',
            },
        ],
        findLabel: 'Find a stadium ↓',
    },
    intro: [
        {
            text: 'The 2026 FIFA World Cup is here, the largest in history, with 48 teams playing across 11 US host cities. ',
        },
        {
            text: 'Wanderu covers the intercity leg:',
            bold: true,
        },
        {
            text: ' buses and trains from wherever you are to the host city. We’ve also included each stadium’s local transit plan, so you know how to get from the city to the game.',
        },
    ],
    masterScheduleSummary: 'Full match schedule — all US group stage games',
    roundOf32Summary: 'Round of 32 — all US knockout games',
    roundOf32: [
        {
            date: 'Jun 28',
            home: 'South Africa',
            away: 'Canada',
            stadiumAnchor: 'los-angeles',
            stadiumLabel: 'Los Angeles',
        },
        {
            date: 'Jun 29',
            home: 'Brazil',
            away: 'Japan',
            stadiumAnchor: 'houston',
            stadiumLabel: 'Houston',
        },
        {
            date: 'Jun 29',
            home: 'Germany',
            away: 'Paraguay',
            stadiumAnchor: 'boston',
            stadiumLabel: 'Boston',
        },
        {
            date: 'Jun 30',
            home: 'France',
            away: 'Sweden',
            stadiumAnchor: 'new-york',
            stadiumLabel: 'New York/NJ',
        },
        {
            date: 'Jun 30',
            home: 'Ivory Coast',
            away: 'Norway',
            stadiumAnchor: 'dallas',
            stadiumLabel: 'Dallas',
        },
        {
            date: 'Jul 1',
            home: 'England',
            away: 'DR Congo',
            stadiumAnchor: 'atlanta',
            stadiumLabel: 'Atlanta',
        },
        {
            date: 'Jul 1',
            home: 'USA',
            away: 'Bosnia and Herzegovina',
            stadiumAnchor: 'san-francisco',
            stadiumLabel: 'SF Bay Area',
        },
        {
            date: 'Jul 1',
            home: 'Belgium',
            away: 'Senegal',
            stadiumAnchor: 'seattle',
            stadiumLabel: 'Seattle',
        },
        {
            date: 'Jul 2',
            home: 'Spain',
            away: 'Austria',
            stadiumAnchor: 'los-angeles',
            stadiumLabel: 'Los Angeles',
        },
        {
            date: 'Jul 3',
            home: 'Australia',
            away: 'Egypt',
            stadiumAnchor: 'dallas',
            stadiumLabel: 'Dallas',
        },
        {
            date: 'Jul 3',
            home: 'Colombia',
            away: 'Ghana',
            stadiumAnchor: 'kansas-city',
            stadiumLabel: 'Kansas City',
        },
        {
            date: 'Jul 3',
            home: 'Argentina',
            away: 'Cape Verde',
            stadiumAnchor: 'miami',
            stadiumLabel: 'Miami',
        },
    ],
    schedule: [
        {
            date: 'Jun 12',
            home: 'USA',
            away: 'Paraguay',
            group: 'Group D',
            stadiumAnchor: 'los-angeles',
            stadiumLabel: 'Los Angeles',
        },
        {
            date: 'Jun 13',
            home: 'Qatar',
            away: 'Switzerland',
            group: 'Group B',
            stadiumAnchor: 'san-francisco',
            stadiumLabel: 'SF Bay Area',
        },
        {
            date: 'Jun 13',
            home: 'Brazil',
            away: 'Morocco',
            group: 'Group C',
            stadiumAnchor: 'new-york',
            stadiumLabel: 'New York/NJ',
        },
        {
            date: 'Jun 13',
            home: 'Haiti',
            away: 'Scotland',
            group: 'Group C',
            stadiumAnchor: 'boston',
            stadiumLabel: 'Boston',
        },
        {
            date: 'Jun 14',
            home: 'Germany',
            away: 'Curaçao',
            group: 'Group E',
            stadiumAnchor: 'houston',
            stadiumLabel: 'Houston',
        },
        {
            date: 'Jun 14',
            home: 'Netherlands',
            away: 'Japan',
            group: 'Group F',
            stadiumAnchor: 'dallas',
            stadiumLabel: 'Dallas',
        },
        {
            date: 'Jun 14',
            home: 'Ivory Coast',
            away: 'Ecuador',
            group: 'Group E',
            stadiumAnchor: 'philadelphia',
            stadiumLabel: 'Philadelphia',
        },
        {
            date: 'Jun 15',
            home: 'Spain',
            away: 'Cape Verde',
            group: 'Group H',
            stadiumAnchor: 'atlanta',
            stadiumLabel: 'Atlanta',
        },
        {
            date: 'Jun 15',
            home: 'Belgium',
            away: 'Egypt',
            group: 'Group G',
            stadiumAnchor: 'seattle',
            stadiumLabel: 'Seattle',
        },
        {
            date: 'Jun 15',
            home: 'Saudi Arabia',
            away: 'Uruguay',
            group: 'Group H',
            stadiumAnchor: 'miami',
            stadiumLabel: 'Miami',
        },
        {
            date: 'Jun 15',
            home: 'Iran',
            away: 'New Zealand',
            group: 'Group G',
            stadiumAnchor: 'los-angeles',
            stadiumLabel: 'Los Angeles',
        },
        {
            date: 'Jun 16',
            home: 'France',
            away: 'Senegal',
            group: 'Group I',
            stadiumAnchor: 'new-york',
            stadiumLabel: 'New York/NJ',
        },
        {
            date: 'Jun 16',
            home: 'Iraq',
            away: 'Norway',
            group: 'Group I',
            stadiumAnchor: 'boston',
            stadiumLabel: 'Boston',
        },
        {
            date: 'Jun 16',
            home: 'Argentina',
            away: 'Algeria',
            group: 'Group J',
            stadiumAnchor: 'kansas-city',
            stadiumLabel: 'Kansas City',
        },
        {
            date: 'Jun 16',
            home: 'Austria',
            away: 'Jordan',
            group: 'Group J',
            stadiumAnchor: 'san-francisco',
            stadiumLabel: 'SF Bay Area',
        },
        {
            date: 'Jun 17',
            home: 'Portugal',
            away: 'DR Congo',
            group: 'Group K',
            stadiumAnchor: 'houston',
            stadiumLabel: 'Houston',
        },
        {
            date: 'Jun 17',
            home: 'England',
            away: 'Croatia',
            group: 'Group L',
            stadiumAnchor: 'dallas',
            stadiumLabel: 'Dallas',
        },
        {
            date: 'Jun 18',
            home: 'Czechia',
            away: 'South Africa',
            group: 'Group A',
            stadiumAnchor: 'atlanta',
            stadiumLabel: 'Atlanta',
        },
        {
            date: 'Jun 18',
            home: 'Switzerland',
            away: 'Bosnia and Herzegovina',
            group: 'Group B',
            stadiumAnchor: 'los-angeles',
            stadiumLabel: 'Los Angeles',
        },
        {
            date: 'Jun 19',
            home: 'USA',
            away: 'Australia',
            group: 'Group D',
            stadiumAnchor: 'seattle',
            stadiumLabel: 'Seattle',
        },
        {
            date: 'Jun 19',
            home: 'Scotland',
            away: 'Morocco',
            group: 'Group C',
            stadiumAnchor: 'boston',
            stadiumLabel: 'Boston',
        },
        {
            date: 'Jun 19',
            home: 'Brazil',
            away: 'Haiti',
            group: 'Group C',
            stadiumAnchor: 'philadelphia',
            stadiumLabel: 'Philadelphia',
        },
        {
            date: 'Jun 19',
            home: 'Türkiye',
            away: 'Paraguay',
            group: 'Group D',
            stadiumAnchor: 'san-francisco',
            stadiumLabel: 'SF Bay Area',
        },
        {
            date: 'Jun 20',
            home: 'Netherlands',
            away: 'Sweden',
            group: 'Group F',
            stadiumAnchor: 'houston',
            stadiumLabel: 'Houston',
        },
        {
            date: 'Jun 20',
            home: 'Ecuador',
            away: 'Curaçao',
            group: 'Group E',
            stadiumAnchor: 'kansas-city',
            stadiumLabel: 'Kansas City',
        },
        {
            date: 'Jun 21',
            home: 'Spain',
            away: 'Saudi Arabia',
            group: 'Group H',
            stadiumAnchor: 'atlanta',
            stadiumLabel: 'Atlanta',
        },
        {
            date: 'Jun 21',
            home: 'Belgium',
            away: 'Iran',
            group: 'Group G',
            stadiumAnchor: 'los-angeles',
            stadiumLabel: 'Los Angeles',
        },
        {
            date: 'Jun 21',
            home: 'Uruguay',
            away: 'Cape Verde',
            group: 'Group H',
            stadiumAnchor: 'miami',
            stadiumLabel: 'Miami',
        },
        {
            date: 'Jun 22',
            home: 'Argentina',
            away: 'Austria',
            group: 'Group J',
            stadiumAnchor: 'dallas',
            stadiumLabel: 'Dallas',
        },
        {
            date: 'Jun 22',
            home: 'France',
            away: 'Iraq',
            group: 'Group I',
            stadiumAnchor: 'philadelphia',
            stadiumLabel: 'Philadelphia',
        },
        {
            date: 'Jun 22',
            home: 'Norway',
            away: 'Senegal',
            group: 'Group I',
            stadiumAnchor: 'new-york',
            stadiumLabel: 'New York/NJ',
        },
        {
            date: 'Jun 22',
            home: 'Jordan',
            away: 'Algeria',
            group: 'Group J',
            stadiumAnchor: 'san-francisco',
            stadiumLabel: 'SF Bay Area',
        },
        {
            date: 'Jun 23',
            home: 'Portugal',
            away: 'Uzbekistan',
            group: 'Group K',
            stadiumAnchor: 'houston',
            stadiumLabel: 'Houston',
        },
        {
            date: 'Jun 23',
            home: 'England',
            away: 'Ghana',
            group: 'Group L',
            stadiumAnchor: 'boston',
            stadiumLabel: 'Boston',
        },
        {
            date: 'Jun 24',
            home: 'Bosnia and Herzegovina',
            away: 'Qatar',
            group: 'Group B',
            stadiumAnchor: 'seattle',
            stadiumLabel: 'Seattle',
        },
        {
            date: 'Jun 24',
            home: 'Scotland',
            away: 'Brazil',
            group: 'Group C',
            stadiumAnchor: 'miami',
            stadiumLabel: 'Miami',
        },
        {
            date: 'Jun 24',
            home: 'Morocco',
            away: 'Haiti',
            group: 'Group C',
            stadiumAnchor: 'atlanta',
            stadiumLabel: 'Atlanta',
        },
        {
            date: 'Jun 25',
            home: 'Ecuador',
            away: 'Germany',
            group: 'Group E',
            stadiumAnchor: 'new-york',
            stadiumLabel: 'New York/NJ',
        },
        {
            date: 'Jun 25',
            home: 'Curaçao',
            away: 'Ivory Coast',
            group: 'Group E',
            stadiumAnchor: 'philadelphia',
            stadiumLabel: 'Philadelphia',
        },
        {
            date: 'Jun 25',
            home: 'Japan',
            away: 'Sweden',
            group: 'Group F',
            stadiumAnchor: 'dallas',
            stadiumLabel: 'Dallas',
        },
        {
            date: 'Jun 25',
            home: 'Tunisia',
            away: 'Netherlands',
            group: 'Group F',
            stadiumAnchor: 'kansas-city',
            stadiumLabel: 'Kansas City',
        },
        {
            date: 'Jun 25',
            home: 'Türkiye',
            away: 'USA',
            group: 'Group D',
            stadiumAnchor: 'los-angeles',
            stadiumLabel: 'Los Angeles',
        },
        {
            date: 'Jun 25',
            home: 'Paraguay',
            away: 'Australia',
            group: 'Group D',
            stadiumAnchor: 'san-francisco',
            stadiumLabel: 'SF Bay Area',
        },
        {
            date: 'Jun 26',
            home: 'Norway',
            away: 'France',
            group: 'Group I',
            stadiumAnchor: 'boston',
            stadiumLabel: 'Boston',
        },
        {
            date: 'Jun 26',
            home: 'Cape Verde',
            away: 'Saudi Arabia',
            group: 'Group H',
            stadiumAnchor: 'houston',
            stadiumLabel: 'Houston',
        },
        {
            date: 'Jun 26',
            home: 'Egypt',
            away: 'Iran',
            group: 'Group G',
            stadiumAnchor: 'seattle',
            stadiumLabel: 'Seattle',
        },
        {
            date: 'Jun 27',
            home: 'Panama',
            away: 'England',
            group: 'Group L',
            stadiumAnchor: 'new-york',
            stadiumLabel: 'New York/NJ',
        },
        {
            date: 'Jun 27',
            home: 'Croatia',
            away: 'Ghana',
            group: 'Group L',
            stadiumAnchor: 'philadelphia',
            stadiumLabel: 'Philadelphia',
        },
        {
            date: 'Jun 27',
            home: 'Colombia',
            away: 'Portugal',
            group: 'Group K',
            stadiumAnchor: 'miami',
            stadiumLabel: 'Miami',
        },
        {
            date: 'Jun 27',
            home: 'DR Congo',
            away: 'Uzbekistan',
            group: 'Group K',
            stadiumAnchor: 'atlanta',
            stadiumLabel: 'Atlanta',
        },
        {
            date: 'Jun 27',
            home: 'Algeria',
            away: 'Austria',
            group: 'Group J',
            stadiumAnchor: 'kansas-city',
            stadiumLabel: 'Kansas City',
        },
        {
            date: 'Jun 27',
            home: 'Jordan',
            away: 'Argentina',
            group: 'Group J',
            stadiumAnchor: 'dallas',
            stadiumLabel: 'Dallas',
        },
    ],
    stadiums: [
        {
            id: 'atlanta',
            name: 'Atlanta Stadium',
            official: 'Mercedes-Benz Stadium · Atlanta',
            schedule: [
                {
                    date: 'Jun 15',
                    home: 'Spain',
                    away: 'Cape Verde',
                    group: 'Group H',
                },
                {
                    date: 'Jun 18',
                    home: 'Czechia',
                    away: 'South Africa',
                    group: 'Group A',
                },
                {
                    date: 'Jun 21',
                    home: 'Spain',
                    away: 'Saudi Arabia',
                    group: 'Group H',
                },
                {
                    date: 'Jun 24',
                    home: 'Morocco',
                    away: 'Haiti',
                    group: 'Group C',
                },
                {
                    date: 'Jun 27',
                    home: 'DR Congo',
                    away: 'Uzbekistan',
                    group: 'Group K',
                },
            ],
            koNote: 'Also hosts: Round of 32 (Jul 1) · Round of 16 (Jul 7) · Semifinal (Jul 15)',
            cta: {
                busLabel: 'Bus tickets to Atlanta',
                busUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ga/atlanta/',
                trainLabel: 'Train tickets to Atlanta',
                trainUrl: 'https://www.wanderu.com/en-us/train-tickets/us-ga/atlanta/',
            },
            transit: {
                label: 'How to get to Atlanta Stadium during the World Cup',
                tips: [
                    [
                        {
                            text: 'MARTA rail to Vine City Station.',
                            bold: true,
                        },
                        {
                            text: ' A covered pedestrian bridge carries you over Northside Drive to the stadium’s northwest plaza. $2.50 each way.',
                        },
                    ],
                    [
                        {
                            text: 'Trains run ',
                        },
                        {
                            text: 'every 5 minutes',
                            bold: true,
                        },
                        {
                            text: ' on match days. Tap-to-pay with any contactless bank card or mobile wallet at faregates; no vending machine or Breeze card needed.',
                        },
                    ],
                    [
                        {
                            text: 'Coming from Hartsfield-Jackson Airport, take the ',
                        },
                        {
                            text: 'Red or Gold Line',
                            bold: true,
                        },
                        {
                            text: ' to Five Points, then transfer to the Green or Blue Line. Vine City is two stops away; SEC District, one stop away, also serves the stadium. No car, no rideshare, no stress.',
                        },
                    ],
                ],
                transportLink: {
                    label: 'MARTA World Cup guide →',
                    url: 'https://itsmarta.com/worldcup26.aspx',
                },
            },
            routes: [
                {
                    label: 'Birmingham → Atlanta',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-al/birmingham/us-ga/atlanta/',
                    trainUrl: null,
                },
                {
                    label: 'Charlotte → Atlanta',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-nc/charlotte/us-ga/atlanta/',
                    trainUrl: null,
                },
                {
                    label: 'Nashville → Atlanta',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-tn/nashville/us-ga/atlanta/',
                    trainUrl: null,
                },
                {
                    label: 'Knoxville → Atlanta',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-tn/knoxville/us-ga/atlanta/',
                    trainUrl: null,
                },
            ],
            allLink: {
                label: 'Search from any city →',
                url: 'https://www.wanderu.com/en-us/bus-tickets/us-ga/atlanta/',
            },
        },
        {
            id: 'boston',
            name: 'Boston Stadium',
            official: 'Gillette Stadium, Foxborough MA · Boston',
            schedule: [
                {
                    date: 'Jun 13',
                    home: 'Haiti',
                    away: 'Scotland',
                    group: 'Group C',
                },
                {
                    date: 'Jun 16',
                    home: 'Iraq',
                    away: 'Norway',
                    group: 'Group I',
                },
                {
                    date: 'Jun 19',
                    home: 'Scotland',
                    away: 'Morocco',
                    group: 'Group C',
                },
                {
                    date: 'Jun 23',
                    home: 'England',
                    away: 'Ghana',
                    group: 'Group L',
                },
                {
                    date: 'Jun 26',
                    home: 'Norway',
                    away: 'France',
                    group: 'Group I',
                },
            ],
            koNote: 'Also hosts: Round of 32 (Jun 29) · Quarterfinal (Jul 9)',
            cta: {
                busLabel: 'Bus tickets to Boston',
                busUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ma/boston/',
                trainLabel: 'Train tickets to Boston',
                trainUrl: 'https://www.wanderu.com/en-us/train-tickets/us-ma/boston/',
            },
            transit: {
                label: 'How to get to Boston Stadium during the World Cup',
                tips: [
                    [
                        {
                            text: 'MBTA Boston Stadium Train',
                            bold: true,
                        },
                        {
                            text: ': nonstop from South Station (downtown Boston) to Foxboro Station, adjacent to the stadium. About 1 hour. $80 round trip.',
                        },
                    ],
                    [
                        {
                            text: 'Purchase tickets in advance via the ',
                        },
                        {
                            text: 'MBTA mTicket app only',
                            bold: true,
                        },
                        {
                            text: '. A valid World Cup match ticket is required to buy the rail ticket. No day-of purchase available.',
                        },
                    ],
                    [
                        {
                            text: 'Foxboro Station received a ',
                        },
                        {
                            text: '$33 million renovation',
                            bold: true,
                        },
                        {
                            text: ' completed June 2026 with new high-level platforms. Subway service runs until approximately 2 AM after matches, extended to about 4 AM after the Saturday, Jun 13 match.',
                        },
                    ],
                ],
                transportLink: {
                    label: 'MBTA World Cup guide →',
                    url: 'https://www.mbta.com/guides/world-cup-guide',
                },
            },
            routes: [
                {
                    label: 'New York → Boston',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ny/new-york/us-ma/boston/',
                    trainUrl: 'https://www.wanderu.com/en-us/train/us-ny/new-york/us-ma/boston/',
                },
                {
                    label: 'Providence → Boston',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ri/providence/us-ma/boston/',
                    trainUrl: 'https://www.wanderu.com/en-us/train/us-ri/providence/us-ma/boston/',
                },
                {
                    label: 'Hartford → Boston',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ct/hartford/us-ma/boston/',
                    trainUrl: 'https://www.wanderu.com/en-us/train/us-ct/hartford/us-ma/boston/',
                },
                {
                    label: 'Springfield → Boston',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ma/springfield/us-ma/boston/',
                    trainUrl: 'https://www.wanderu.com/en-us/train/us-ma/springfield/us-ma/boston/',
                },
            ],
            allLink: {
                label: 'Search from any city →',
                url: 'https://www.wanderu.com/en-us/bus-tickets/us-ma/boston/',
            },
        },
        {
            id: 'dallas',
            name: 'Dallas Stadium',
            official: 'AT&T Stadium, Arlington TX · Dallas',
            schedule: [
                {
                    date: 'Jun 14',
                    home: 'Netherlands',
                    away: 'Japan',
                    group: 'Group F',
                },
                {
                    date: 'Jun 17',
                    home: 'England',
                    away: 'Croatia',
                    group: 'Group L',
                },
                {
                    date: 'Jun 22',
                    home: 'Argentina',
                    away: 'Austria',
                    group: 'Group J',
                },
                {
                    date: 'Jun 25',
                    home: 'Japan',
                    away: 'Sweden',
                    group: 'Group F',
                },
                {
                    date: 'Jun 27',
                    home: 'Jordan',
                    away: 'Argentina',
                    group: 'Group J',
                },
            ],
            koNote: 'Also hosts: Round of 32 ×2 (Jun 30, Jul 3) · Round of 16 (Jul 6) · Semifinal (Jul 14)',
            cta: {
                busLabel: 'Bus tickets to Dallas',
                busUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-tx/dallas/',
                trainLabel: 'Train tickets to Dallas',
                trainUrl: 'https://www.wanderu.com/en-us/train-tickets/us-tx/dallas/',
            },
            transit: {
                label: 'How to get to Dallas Stadium during the World Cup',
                tips: [
                    [
                        {
                            text: 'AT&T Stadium in Arlington has ',
                        },
                        {
                            text: 'no direct rail connection',
                            bold: true,
                        },
                        {
                            text: '. The closest you can get by train is CentrePort Station, via the Trinity Railway Express (TRE), which runs between Victory Station (Dallas) and Fort Worth Central.',
                        },
                    ],
                    [
                        {
                            text: 'Complimentary charter buses',
                            bold: true,
                        },
                        {
                            text: ' run from CentrePort to the stadium on match days (free with your match ticket), about 1.5 hours total from downtown Dallas. The ',
                        },
                        {
                            text: 'GoPass app',
                            bold: true,
                        },
                        {
                            text: ' covers DART + TRE in one pass.',
                        },
                    ],
                    [
                        {
                            text: 'Official stadium parking must be reserved in advance — no on-site sales. Rideshare and taxi drop-off is designated at Esports Stadium Arlington, about 0.7 miles (a 10–15 minute walk) from the stadium.',
                        },
                    ],
                ],
                transportLink: {
                    label: 'Dallas FWC26 transport guide →',
                    url: 'https://www.dallasfwc26.com/dallas-2026/transportation-mobility/',
                },
            },
            routes: [
                {
                    label: 'Houston → Dallas',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-tx/houston/us-tx/dallas/',
                    trainUrl: null,
                },
                {
                    label: 'Austin → Dallas',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-tx/austin/us-tx/dallas/',
                    trainUrl: null,
                },
                {
                    label: 'San Antonio → Dallas',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-tx/san-antonio/us-tx/dallas/',
                    trainUrl: null,
                },
                {
                    label: 'Oklahoma City → Dallas',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ok/oklahoma-city/us-tx/dallas/',
                    trainUrl: null,
                },
            ],
            allLink: {
                label: 'Search from any city →',
                url: 'https://www.wanderu.com/en-us/bus-tickets/us-tx/dallas/',
            },
        },
        {
            id: 'houston',
            name: 'Houston Stadium',
            official: 'NRG Stadium · Houston',
            schedule: [
                {
                    date: 'Jun 14',
                    home: 'Germany',
                    away: 'Curaçao',
                    group: 'Group E',
                },
                {
                    date: 'Jun 17',
                    home: 'Portugal',
                    away: 'DR Congo',
                    group: 'Group K',
                },
                {
                    date: 'Jun 20',
                    home: 'Netherlands',
                    away: 'Sweden',
                    group: 'Group F',
                },
                {
                    date: 'Jun 23',
                    home: 'Portugal',
                    away: 'Uzbekistan',
                    group: 'Group K',
                },
                {
                    date: 'Jun 26',
                    home: 'Cape Verde',
                    away: 'Saudi Arabia',
                    group: 'Group H',
                },
            ],
            koNote: 'Also hosts: Round of 32 (Jun 29) · Round of 16 (Jul 4)',
            cta: {
                busLabel: 'Bus tickets to Houston',
                busUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-tx/houston/',
                trainLabel: 'Train tickets to Houston',
                trainUrl: 'https://www.wanderu.com/en-us/train-tickets/us-tx/houston/',
            },
            transit: {
                label: 'How to get to Houston Stadium during the World Cup',
                tips: [
                    [
                        {
                            text: 'METRORail Red Line',
                            bold: true,
                        },
                        {
                            text: ' runs directly to NRG Park for $1.25 each way, the most affordable direct rail connection to any US World Cup stadium.',
                        },
                    ],
                    [
                        {
                            text: 'Trains run ',
                        },
                        {
                            text: 'every 6–12 minutes',
                            bold: true,
                        },
                        {
                            text: ' on match days. Pay with the RideMETRO card, contactless bank card, Apple Pay, Google Pay, or cash on buses.',
                        },
                    ],
                    [
                        {
                            text: 'Board at any downtown Houston station on Main Street. The Red Line takes about 25–30 minutes to Stadium Park/Astrodome Station, then it’s a 10-minute walk to the gates.',
                        },
                    ],
                ],
                transportLink: {
                    label: 'Houston METRO World Cup guide →',
                    url: 'https://www.ridemetro.org/world-cup',
                },
            },
            routes: [
                {
                    label: 'Dallas → Houston',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-tx/dallas/us-tx/houston/',
                    trainUrl: null,
                },
                {
                    label: 'San Antonio → Houston',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-tx/san-antonio/us-tx/houston/',
                    trainUrl: null,
                },
                {
                    label: 'Austin → Houston',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-tx/austin/us-tx/houston/',
                    trainUrl: null,
                },
            ],
            allLink: {
                label: 'Search from any city →',
                url: 'https://www.wanderu.com/en-us/bus-tickets/us-tx/houston/',
            },
        },
        {
            id: 'kansas-city',
            name: 'Kansas City Stadium',
            official: 'Arrowhead Stadium · Kansas City',
            schedule: [
                {
                    date: 'Jun 16',
                    home: 'Argentina',
                    away: 'Algeria',
                    group: 'Group J',
                },
                {
                    date: 'Jun 20',
                    home: 'Ecuador',
                    away: 'Curaçao',
                    group: 'Group E',
                },
                {
                    date: 'Jun 25',
                    home: 'Tunisia',
                    away: 'Netherlands',
                    group: 'Group F',
                },
                {
                    date: 'Jun 27',
                    home: 'Algeria',
                    away: 'Austria',
                    group: 'Group J',
                },
            ],
            koNote: 'Also hosts: Round of 32 (Jul 3) · Quarterfinal (Jul 11)',
            cta: {
                busLabel: 'Bus tickets to Kansas City',
                busUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-mo/kansas-city/',
                trainLabel: 'Train tickets to Kansas City',
                trainUrl: 'https://www.wanderu.com/en-us/train-tickets/us-mo/kansas-city/',
            },
            transit: {
                label: 'How to get to Kansas City Stadium during the World Cup',
                tips: [
                    [
                        {
                            text: 'No rail connects to Arrowhead Stadium.',
                            bold: true,
                        },
                        {
                            text: ' ConnectKC26 match-day shuttles cost ',
                        },
                        {
                            text: '$15 round trip',
                            bold: true,
                        },
                        {
                            text: ' from 6 departure points across the metro (the ConnectKC26 Bus Mall, The Plaza, and 4 park-and-ride locations). Runs from 3 hrs before kickoff until 2 hrs after the match ends.',
                        },
                    ],
                    [
                        {
                            text: 'Stadium parking is ',
                        },
                        {
                            text: 'extremely limited',
                            bold: true,
                        },
                        {
                            text: ' for World Cup matches and priced at a significant premium. The shuttle is strongly recommended.',
                        },
                    ],
                    [
                        {
                            text: 'Pick-up locations: the ConnectKC26 Bus Mall (2 blocks from the FIFA Fan Festival), The Plaza, and 4 park-and-rides — Graceway (Raytown), Independence Center, North KC, and Oak Park Mall. “Airport Direct” buses also run free from KCI Airport to downtown.',
                        },
                    ],
                ],
                transportLink: {
                    label: 'Kansas City FWC26 transport guide →',
                    url: 'https://kansascityfwc26.com/getting-around-kc/',
                },
            },
            routes: [
                {
                    label: 'St. Louis → Kansas City',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-mo/st-louis/us-mo/kansas-city/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-mo/st-louis/us-mo/kansas-city/',
                },
                {
                    label: 'Omaha → Kansas City',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ne/omaha/us-mo/kansas-city/',
                    trainUrl: null,
                },
                {
                    label: 'Wichita → Kansas City',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ks/wichita/us-mo/kansas-city/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-ks/wichita/us-mo/kansas-city/',
                },
                {
                    label: 'Oklahoma City → Kansas City',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ok/oklahoma-city/us-mo/kansas-city/',
                    trainUrl: null,
                },
            ],
            allLink: {
                label: 'Search from any city →',
                url: 'https://www.wanderu.com/en-us/bus-tickets/us-mo/kansas-city/',
            },
        },
        {
            id: 'los-angeles',
            name: 'Los Angeles Stadium',
            official: 'SoFi Stadium · Los Angeles',
            schedule: [
                {
                    date: 'Jun 12',
                    home: 'USA',
                    away: 'Paraguay',
                    group: 'Group D',
                },
                {
                    date: 'Jun 15',
                    home: 'Iran',
                    away: 'New Zealand',
                    group: 'Group G',
                },
                {
                    date: 'Jun 18',
                    home: 'Switzerland',
                    away: 'Bosnia and Herzegovina',
                    group: 'Group B',
                },
                {
                    date: 'Jun 21',
                    home: 'Belgium',
                    away: 'Iran',
                    group: 'Group G',
                },
                {
                    date: 'Jun 25',
                    home: 'Türkiye',
                    away: 'USA',
                    group: 'Group D',
                },
            ],
            koNote: 'Also hosts: Round of 32 ×2 (Jun 28, Jul 2) · Quarterfinal (Jul 10)',
            cta: {
                busLabel: 'Bus tickets to Los Angeles',
                busUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ca/los-angeles/',
                trainLabel: 'Train tickets to Los Angeles',
                trainUrl: 'https://www.wanderu.com/en-us/train-tickets/us-ca/los-angeles/',
            },
            transit: {
                label: 'How to get to Los Angeles Stadium during the World Cup',
                tips: [
                    [
                        {
                            text: 'No direct rail to SoFi Stadium.',
                            bold: true,
                        },
                        {
                            text: " You'll need a match-day shuttle bus from a Metro station or park-and-ride.",
                        },
                    ],
                    [
                        {
                            text: 'LA Metro',
                            bold: true,
                        },
                        {
                            text: ' runs match-day shuttle buses from 15 pickup points across the region. $1.75 each way. Shuttles start 3–4 hours before kickoff.',
                        },
                    ],
                    [
                        {
                            text: 'Major pickup locations include LAX/Metro Transit Center (C and K Lines), Hawthorne/Lennox (C Line), Union Station, and Downtown Long Beach. Frequency is every 10 minutes from major hubs.',
                        },
                    ],
                ],
                transportLink: {
                    label: 'LA Metro World Cup guide →',
                    url: 'https://www.metro.net/riding/world-cup/',
                },
            },
            routes: [
                {
                    label: 'San Diego → Los Angeles',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ca/san-diego/us-ca/los-angeles/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-ca/san-diego/us-ca/los-angeles/',
                },
                {
                    label: 'Las Vegas → Los Angeles',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-nv/las-vegas/us-ca/los-angeles/',
                    trainUrl: null,
                },
                {
                    label: 'San Francisco → Los Angeles',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ca/san-francisco/us-ca/los-angeles/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-ca/san-francisco/us-ca/los-angeles/',
                },
                {
                    label: 'Santa Barbara → Los Angeles',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ca/santa-barbara/us-ca/los-angeles/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-ca/santa-barbara/us-ca/los-angeles/',
                },
            ],
            allLink: {
                label: 'Search from any city →',
                url: 'https://www.wanderu.com/en-us/bus-tickets/us-ca/los-angeles/',
            },
        },
        {
            id: 'miami',
            name: 'Miami Stadium',
            official: 'Hard Rock Stadium, Miami Gardens FL · Miami',
            schedule: [
                {
                    date: 'Jun 15',
                    home: 'Saudi Arabia',
                    away: 'Uruguay',
                    group: 'Group H',
                },
                {
                    date: 'Jun 21',
                    home: 'Uruguay',
                    away: 'Cape Verde',
                    group: 'Group H',
                },
                {
                    date: 'Jun 24',
                    home: 'Scotland',
                    away: 'Brazil',
                    group: 'Group C',
                },
                {
                    date: 'Jun 27',
                    home: 'Colombia',
                    away: 'Portugal',
                    group: 'Group K',
                },
            ],
            koNote: 'Also hosts: Round of 32 (Jul 3) · Quarterfinal (Jul 11) · Third-Place Match (Jul 18)',
            cta: {
                busLabel: 'Bus tickets to Miami',
                busUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-fl/miami/',
                trainLabel: 'Train tickets to Miami',
                trainUrl: 'https://www.wanderu.com/en-us/train-tickets/us-fl/miami/',
            },
            transit: {
                label: 'How to get to Miami Stadium during the World Cup',
                tips: [
                    [
                        {
                            text: 'Free match-day shuttles',
                            bold: true,
                        },
                        {
                            text: ' run from Aventura Station (Brightline) and 3 other transit hubs to the stadium. A valid match ticket is required to board; first-come, first-served.',
                        },
                    ],
                    [
                        {
                            text: 'Brightline',
                            bold: true,
                        },
                        {
                            text: ' connects Fort Lauderdale, West Palm Beach, and Orlando directly to Aventura Station. Brightline tickets are bookable on Wanderu.',
                        },
                    ],
                    [
                        {
                            text: 'Miami-Dade Metrorail, Metrobus, Tri-Rail, and park-and-ride lots also connect to the shuttle hubs. Plan your full trip at the Miami-Dade mobility guide.',
                        },
                    ],
                ],
                transportLink: {
                    label: 'Miami-Dade World Cup mobility guide →',
                    url: 'https://www.miamidade.gov/wc26mobility/',
                },
            },
            routes: [
                {
                    label: 'Fort Lauderdale → Miami',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-fl/fort-lauderdale/us-fl/miami/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-fl/fort-lauderdale/us-fl/miami/',
                },
                {
                    label: 'West Palm Beach → Miami',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-fl/west-palm-beach/us-fl/miami/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-fl/west-palm-beach/us-fl/miami/',
                },
                {
                    label: 'Orlando → Miami',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-fl/orlando/us-fl/miami/',
                    trainUrl: 'https://www.wanderu.com/en-us/train/us-fl/orlando/us-fl/miami/',
                },
                {
                    label: 'Tampa → Miami',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-fl/tampa/us-fl/miami/',
                    trainUrl: null,
                },
            ],
            allLink: {
                label: 'Search from any city →',
                url: 'https://www.wanderu.com/en-us/bus-tickets/us-fl/miami/',
            },
        },
        {
            id: 'new-york',
            name: 'New York New Jersey Stadium',
            official: 'MetLife Stadium, East Rutherford NJ · New York / New Jersey',
            schedule: [
                {
                    date: 'Jun 13',
                    home: 'Brazil',
                    away: 'Morocco',
                    group: 'Group C',
                },
                {
                    date: 'Jun 16',
                    home: 'France',
                    away: 'Senegal',
                    group: 'Group I',
                },
                {
                    date: 'Jun 22',
                    home: 'Norway',
                    away: 'Senegal',
                    group: 'Group I',
                },
                {
                    date: 'Jun 25',
                    home: 'Ecuador',
                    away: 'Germany',
                    group: 'Group E',
                },
                {
                    date: 'Jun 27',
                    home: 'Panama',
                    away: 'England',
                    group: 'Group L',
                },
            ],
            koNote: 'Also hosts: Round of 32 (Jun 30) · Round of 16 (Jul 5) · ★ Final (Jul 19)',
            cta: {
                busLabel: 'Bus tickets to New York',
                busUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ny/new-york/',
                trainLabel: 'Train tickets to New York',
                trainUrl: 'https://www.wanderu.com/en-us/train-tickets/us-ny/new-york/',
            },
            transit: {
                label: 'How to get to New York New Jersey Stadium during the World Cup',
                tips: [
                    [
                        {
                            text: 'NJ Transit rail',
                            bold: true,
                        },
                        {
                            text: ' from Penn Station (Manhattan) to Secaucus Junction, then transfer to a match-day train to the stadium. Ticket prices and service details are confirmed on NJ Transit’s FIFA page. Purchase in advance via the NJ Transit app. A valid match ticket is required to buy.',
                        },
                    ],
                    [
                        {
                            text: 'No general parking at MetLife on match days. Service is restricted to FIFA ticket holders starting 4 hours before kickoff.',
                        },
                    ],
                    [
                        {
                            text: 'MTA is boosting subway frequency on the C, 1, and F lines to handle increased match-day crowds, plus extra 7 train service Jun 11–27 for the FIFA fan celebration in Queens.',
                        },
                    ],
                ],
                transportLink: {
                    label: 'NJ Transit FIFA 2026 guide →',
                    url: 'https://www.njtransit.com/fifa2026',
                },
            },
            routes: [
                {
                    label: 'Philadelphia → New York',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-pa/philadelphia/us-ny/new-york/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-pa/philadelphia/us-ny/new-york/',
                },
                {
                    label: 'Boston → New York',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ma/boston/us-ny/new-york/',
                    trainUrl: 'https://www.wanderu.com/en-us/train/us-ma/boston/us-ny/new-york/',
                },
                {
                    label: 'Washington DC → New York',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-dc/washington/us-ny/new-york/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-dc/washington/us-ny/new-york/',
                },
                {
                    label: 'Baltimore → New York',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-md/baltimore/us-ny/new-york/',
                    trainUrl: 'https://www.wanderu.com/en-us/train/us-md/baltimore/us-ny/new-york/',
                },
                {
                    label: 'Providence → New York',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ri/providence/us-ny/new-york/',
                    trainUrl: null,
                },
            ],
            allLink: {
                label: 'Search from any city →',
                url: 'https://www.wanderu.com/en-us/bus-tickets/us-ny/new-york/',
            },
        },
        {
            id: 'philadelphia',
            name: 'Philadelphia Stadium',
            official: 'Lincoln Financial Field · Philadelphia',
            schedule: [
                {
                    date: 'Jun 14',
                    home: 'Ivory Coast',
                    away: 'Ecuador',
                    group: 'Group E',
                },
                {
                    date: 'Jun 19',
                    home: 'Brazil',
                    away: 'Haiti',
                    group: 'Group C',
                },
                {
                    date: 'Jun 22',
                    home: 'France',
                    away: 'Iraq',
                    group: 'Group I',
                },
                {
                    date: 'Jun 25',
                    home: 'Curaçao',
                    away: 'Ivory Coast',
                    group: 'Group E',
                },
                {
                    date: 'Jun 27',
                    home: 'Croatia',
                    away: 'Ghana',
                    group: 'Group L',
                },
            ],
            koNote: 'Also hosts: Round of 16 (Jul 4)',
            cta: {
                busLabel: 'Bus tickets to Philadelphia',
                busUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-pa/philadelphia/',
                trainLabel: 'Train tickets to Philadelphia',
                trainUrl: 'https://www.wanderu.com/en-us/train-tickets/us-pa/philadelphia/',
            },
            transit: {
                label: 'How to get to Philadelphia Stadium during the World Cup',
                tips: [
                    [
                        {
                            text: 'SEPTA Broad Street Line (B Line)',
                            bold: true,
                        },
                        {
                            text: ' to NRG Station (formerly AT&T/Pattison Station) at the South Philadelphia Sports Complex. Standard $2.90 fare each way. Contactless payment accepted for up to 5 riders at once.',
                        },
                    ],
                    [
                        {
                            text: 'Free rides home (reportedly Airbnb-sponsored) have been announced starting at halftime through 2 hours after the final whistle. Verify details at the SEPTA World Cup page before your trip.',
                        },
                    ],
                    [
                        {
                            text: 'SEPTA adds 10 extra trains on the B Line (Broad Street Line) before each match. Free rides run every 10 minutes or less. Overnight service runs every 30 min to select stations on both the B Line and the L (Market-Frankford) lines after matches.',
                        },
                    ],
                ],
                transportLink: {
                    label: 'SEPTA World Cup guide →',
                    url: 'https://www.septa.org/info/world-cup-soccer-septa/',
                },
            },
            routes: [
                {
                    label: 'New York → Philadelphia',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ny/new-york/us-pa/philadelphia/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-ny/new-york/us-pa/philadelphia/',
                },
                {
                    label: 'Washington DC → Philadelphia',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-dc/washington/us-pa/philadelphia/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-dc/washington/us-pa/philadelphia/',
                },
                {
                    label: 'Baltimore → Philadelphia',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-md/baltimore/us-pa/philadelphia/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-md/baltimore/us-pa/philadelphia/',
                },
                {
                    label: 'Boston → Philadelphia',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ma/boston/us-pa/philadelphia/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-ma/boston/us-pa/philadelphia/',
                },
            ],
            allLink: {
                label: 'Search from any city →',
                url: 'https://www.wanderu.com/en-us/bus-tickets/us-pa/philadelphia/',
            },
        },
        {
            id: 'san-francisco',
            name: 'San Francisco Bay Area Stadium',
            official: "Levi's Stadium, Santa Clara · San Francisco Bay Area",
            schedule: [
                {
                    date: 'Jun 13',
                    home: 'Qatar',
                    away: 'Switzerland',
                    group: 'Group B',
                },
                {
                    date: 'Jun 16',
                    home: 'Austria',
                    away: 'Jordan',
                    group: 'Group J',
                },
                {
                    date: 'Jun 19',
                    home: 'Türkiye',
                    away: 'Paraguay',
                    group: 'Group D',
                },
                {
                    date: 'Jun 22',
                    home: 'Jordan',
                    away: 'Algeria',
                    group: 'Group J',
                },
                {
                    date: 'Jun 25',
                    home: 'Paraguay',
                    away: 'Australia',
                    group: 'Group D',
                },
            ],
            koNote: 'Also hosts: Round of 32 (Jul 1)',
            cta: {
                busLabel: 'Bus tickets to San Francisco',
                busUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ca/san-francisco/',
                trainLabel: 'Train tickets to San Francisco',
                trainUrl: 'https://www.wanderu.com/en-us/train-tickets/us-ca/san-francisco/',
            },
            transit: {
                label: 'How to get to San Francisco Bay Area Stadium during the World Cup',
                tips: [
                    [
                        {
                            text: 'Take ',
                        },
                        {
                            text: 'Caltrain',
                            bold: true,
                        },
                        {
                            text: ' from San Francisco to Mountain View (45–60 min depending on train type). Runs every 30 minutes on weekends, with extra trains on match days.',
                        },
                    ],
                    [
                        {
                            text: 'Transfer to ',
                        },
                        {
                            text: 'VTA Orange Line',
                            bold: true,
                        },
                        {
                            text: ' light rail at Mountain View to Great America Station (~15 min), then about a 10-minute walk along the stadium promenade.',
                        },
                    ],
                    [
                        {
                            text: 'Stadium parking must be pre-purchased — one pass per match ticket, no day-of sales. Caltrain is the recommended option. Plan your trip using the Caltrain World Cup guide.',
                        },
                    ],
                ],
                transportLink: {
                    label: 'Caltrain World Cup guide →',
                    url: 'https://www.caltrain.com/worldcup26',
                },
            },
            routes: [
                {
                    label: 'Sacramento → San Francisco',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ca/sacramento/us-ca/san-francisco/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-ca/sacramento/us-ca/san-francisco/',
                },
                {
                    label: 'Los Angeles → San Francisco',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ca/los-angeles/us-ca/san-francisco/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-ca/los-angeles/us-ca/san-francisco/',
                },
                {
                    label: 'Fresno → San Francisco',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-ca/fresno/us-ca/san-francisco/',
                    trainUrl:
                        'https://www.wanderu.com/en-us/train/us-ca/fresno/us-ca/san-francisco/',
                },
            ],
            allLink: {
                label: 'Search from any city →',
                url: 'https://www.wanderu.com/en-us/bus-tickets/us-ca/san-francisco/',
            },
        },
        {
            id: 'seattle',
            name: 'Seattle Stadium',
            official: 'Lumen Field · Seattle',
            schedule: [
                {
                    date: 'Jun 15',
                    home: 'Belgium',
                    away: 'Egypt',
                    group: 'Group G',
                },
                {
                    date: 'Jun 19',
                    home: 'USA',
                    away: 'Australia',
                    group: 'Group D',
                },
                {
                    date: 'Jun 24',
                    home: 'Bosnia and Herzegovina',
                    away: 'Qatar',
                    group: 'Group B',
                },
                {
                    date: 'Jun 26',
                    home: 'Egypt',
                    away: 'Iran',
                    group: 'Group G',
                },
            ],
            koNote: 'Also hosts: Round of 32 (Jul 1) · Round of 16 (Jul 6)',
            cta: {
                busLabel: 'Bus tickets to Seattle',
                busUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-wa/seattle/',
                trainLabel: 'Train tickets to Seattle',
                trainUrl: 'https://www.wanderu.com/en-us/train-tickets/us-wa/seattle/',
            },
            transit: {
                label: 'How to get to Seattle Stadium during the World Cup',
                tips: [
                    [
                        {
                            text: 'Link light rail',
                            bold: true,
                        },
                        {
                            text: ' (1 Line) stops directly at Stadium Station, one stop south of downtown Seattle. Flat $3.00 adult fare, any distance — tap-on only, no tap-off. Contactless bank card accepted at all gates.',
                        },
                    ],
                    [
                        {
                            text: 'Trains will arrive ',
                        },
                        {
                            text: 'every 8 minutes',
                            bold: true,
                        },
                        {
                            text: ' on match days. Direct from Sea-Tac Airport with no transfers, about 40 minutes airport to stadium.',
                        },
                    ],
                    [
                        {
                            text: 'A ',
                        },
                        {
                            text: '3-day unlimited ORCA pass',
                            bold: true,
                        },
                        {
                            text: ' is available for $18 for visitors, covering most Sound Transit and King County Metro services including Link light rail. (Note: Sounder commuter trains are only partially covered: the pass covers the first $3 of the fare.)',
                        },
                    ],
                ],
                transportLink: {
                    label: 'Seattle World Cup transit guide →',
                    url: 'https://info.myorca.com/seattle-soccer-2026/',
                },
            },
            routes: [
                {
                    label: 'Portland → Seattle',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-or/portland/us-wa/seattle/',
                    trainUrl: 'https://www.wanderu.com/en-us/train/us-or/portland/us-wa/seattle/',
                },
                {
                    label: 'Vancouver → Seattle',
                    busUrl: 'https://www.wanderu.com/en-us/bus/ca-bc/vancouver/us-wa/seattle/',
                    trainUrl: 'https://www.wanderu.com/en-us/train/ca-bc/vancouver/us-wa/seattle/',
                },
                {
                    label: 'Spokane → Seattle',
                    busUrl: 'https://www.wanderu.com/en-us/bus/us-wa/spokane/us-wa/seattle/',
                    trainUrl: 'https://www.wanderu.com/en-us/train/us-wa/spokane/us-wa/seattle/',
                },
            ],
            allLink: {
                label: 'Search from any city →',
                url: 'https://www.wanderu.com/en-us/bus-tickets/us-wa/seattle/',
            },
        },
    ],
    bottom: {
        heading: 'Find your ride to the World Cup.',
        sub: 'Cheap buses and trains to all 11 US host cities.',
        ctaLabel: 'Search tickets',
        ctaUrl: 'https://www.wanderu.com/',
    },
    teams: {
        Algeria: 'dz',
        Argentina: 'ar',
        Australia: 'au',
        Austria: 'at',
        Belgium: 'be',
        'Bosnia and Herzegovina': 'ba',
        Brazil: 'br',
        Canada: 'ca',
        'Cape Verde': 'cv',
        Colombia: 'co',
        Croatia: 'hr',
        Curaçao: 'cw',
        Czechia: 'cz',
        'DR Congo': 'cd',
        Ecuador: 'ec',
        Egypt: 'eg',
        England: 'gb-eng',
        France: 'fr',
        Germany: 'de',
        Ghana: 'gh',
        Haiti: 'ht',
        Iran: 'ir',
        Iraq: 'iq',
        'Ivory Coast': 'ci',
        Japan: 'jp',
        Jordan: 'jo',
        Morocco: 'ma',
        Netherlands: 'nl',
        'New Zealand': 'nz',
        Norway: 'no',
        Panama: 'pa',
        Paraguay: 'py',
        Portugal: 'pt',
        Qatar: 'qa',
        'Saudi Arabia': 'sa',
        Scotland: 'gb-sct',
        Senegal: 'sn',
        'South Africa': 'za',
        'South Korea': 'kr',
        Spain: 'es',
        Sweden: 'se',
        Switzerland: 'ch',
        Tunisia: 'tn',
        Türkiye: 'tr',
        Uruguay: 'uy',
        USA: 'us',
        Uzbekistan: 'uz',
    },
}

export const {
    hero,
    intro,
    masterScheduleSummary,
    schedule,
    roundOf32Summary,
    roundOf32,
    stadiums,
    bottom,
    teams,
} = worldCupContent
